import {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {Content} from '../../../_metronic/layout/components/content'
import {OverviewCard} from './OverviewCard'
import {BASE_URL} from '../config'
import {ICategoryCount} from './core/_model'
import {useQuery} from 'react-query'
import axios from 'axios'
import {searchItems} from '../../utils/helperFunction/_helper'
import {Link} from 'react-router-dom'

const GET_CATEGORIES_ARTICLE_COUNT = `${BASE_URL}/api/protect/getKnowledgeCountByCategory`

const KnowledgeBaseOverview = () => {
  const [categoryCount, setCategoryCount] = useState<ICategoryCount[]>([])

  const [searchTerm, setSearchTerm] = useState('')

  const {data, isLoading, error} = useQuery({
    queryKey: ['categoryCount'],
    queryFn: async () => {
      const response = await axios.get(GET_CATEGORIES_ARTICLE_COUNT)
      const data = await response.data

      return data
    },
  })

  useEffect(() => {
    if (data) {
      const keys: (keyof ICategoryCount)[] = ['total', 'category_name']
      const filtered = searchItems(data, searchTerm, keys)
      setCategoryCount(filtered || [])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchTerm])

  return (
    <>
      <div className=''>
        <p className='fs-2 fw-semibold text-gray-800'>Quick Search</p>
        <div className='d-flex align-items-center position-relative my-1 w-500px'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-700'
            placeholder='Search by category name'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className='row g-5 g-xl-8 mt-6'>
        {isLoading && !data ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {categoryCount.length > 0 ? (
              <>
                {categoryCount.map((category) => (
                  <div className='col-xl-4' key={category.category_id}>
                    <OverviewCard
                      className='card-xl-stretch mb-xl-8'
                      image='abstract-1.svg'
                      title={category.category_name}
                      articleCount={category.total}
                      description=''
                      categoryId={category.category_id}
                    />
                  </div>
                ))}
              </>
            ) : (
              <div className='text-center mt-10'>
                <p className='fs-4 text-gray-800 mt-4'>
                  No category available, please create category.
                </p>
                <Link to='/knowledgebase/category' className='btn btn-success'>
                  Add Category
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default KnowledgeBaseOverview
